'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".ReturnReasons-module_rootWrapper__3YNN-{align-items:center;display:flex;flex-direction:column;flex-grow:1;justify-content:center}.ReturnReasons-module_wrapper__yBs-Z{display:flex;gap:20px;justify-content:center;padding-top:50px;width:80%}.ReturnReasons-module_userActions__YTsFd{align-items:center;display:flex;flex-direction:column;gap:20px;min-width:50%;width:100%}.ReturnReasons-module_backButtonWrapper__ZB0Nc{left:0;padding:20px;position:absolute;top:20px}";
var styles = {"rootWrapper":"ReturnReasons-module_rootWrapper__3YNN-","wrapper":"ReturnReasons-module_wrapper__yBs-Z","userActions":"ReturnReasons-module_userActions__YTsFd","backButtonWrapper":"ReturnReasons-module_backButtonWrapper__ZB0Nc"};
styleInject["default"](css_248z, '5b5e0306-37ad-46e7-8c87-659b4736c3b9');

exports["default"] = styles;
